<template>
  <page-component
    id="webaccountsettings"
    :header="header">
    <div
      id="webaccountsettings_requiredNotice"
      class="paragraph">
      <p>Fields marked with an asterisk ( * ) are required.</p>
    </div>
    <VeeForm
      as=""
      ref="veeForm"
      v-slot="{ errors }">
      <form
        ref="form"
        class="novalidate"
        :action="baseHref + 'account.html'"
        method="post"
        @submit.prevent="onSubmit()">
        <input
          type="hidden"
          name="Action"
          value="process" />
        <input
          type="hidden"
          name="SubAction"
          value="" />
        <input
          type="hidden"
          name="_csrf_token"
          :value="crsf" />
        <input
          v-if="isInvite"
          type="hidden"
          name="inviteid"
          :value="inviteid" />

        <group-component header="Account Details">
          <Field
            name="username"
            label="Username"
            rules="required"
            value=""
            v-model="internalUsername"
            v-slot="{ componentField }">
            <fillin-component
              id="webaccount_username"
              label="Username:"
              type="text"
              autocompleteAttribute="username"
              formInputName="webaccount_username"
              v-bind="componentField"
              :max-length="100"
              :errorMessages="errors.username ? [errors.username] : []"
              required
              newline>
            </fillin-component>
          </Field>

          <Field
            name="email"
            label="Email"
            rules="required|email"
            v-model="internalEmail"
            v-slot="{ componentField }">
            <fillin-component
              id="webaccount_email"
              label="Email:"
              type="text"
              autocompleteAttribute="email"
              formInputName="webaccount_email"
              v-bind="componentField"
              :max-length="100"
              :errorMessages="errors.email ? [errors.email] : []"
              required
              newline>
            </fillin-component>
          </Field>

          <checkbox-component
            id="webaccount_optin"
            label="Subscribe to Future Marketing Communications?"
            formInputName="webaccount_optin"
            v-model="internalOptIn"
            labelRight
            newline>
          </checkbox-component>

          <button
            v-if="!isInvite"
            id="webaccountmanagement_buttonchangedetails"
            type="button"
            class="button primary"
            :disabled="processing"
            @click.prevent="onSubmitDetails()">
            Update Details
          </button>
        </group-component>

        <group-component
          header="Account Password"
          :collapsible="!isInvite"
          :collapsed="!isInvite && !outerrormessage">
          <Field
            v-if="!isInvite"
            name="password"
            label="Existing Password"
            rules="required"
            v-model="internalPassword"
            v-slot="{ componentField }">
            <fillin-component
              id="webaccount_password"
              label="Existing Password:"
              type="password"
              autocompleteAttribute="current-password"
              formInputName="webaccount_password"
              v-bind="componentField"
              :errorMessages="errors.password ? [errors.password] : []"
              required
              newline>
            </fillin-component>
          </Field>

          <Field
            name="newpassword1"
            label="Password"
            rules="required"
            v-model="internalNewPassword1"
            v-slot="{ componentField }">
            <fillin-component
              id="webaccount_newpassword1"
              :label="isInvite ? 'Password:' : 'New Password:'"
              type="password"
              autocompleteAttribute="new-password"
              formInputName="webaccount_newpassword1"
              v-bind="componentField"
              :errorMessages="errors.newpassword1 ? [errors.newpassword1] : []"
              required
              newline>
            </fillin-component>
          </Field>

          <Field
            name="newpassword2"
            label="Confirm Password"
            rules="required|confirmed:@newpassword1"
            v-model="internalNewPassword2"
            v-slot="{ componentField }">
            <fillin-component
              id="webaccount_newpassword2"
              :label="isInvite ? 'Confirm Password:' : 'Confirm New Password:'"
              type="password"
              autocompleteAttribute="new-password"
              formInputName="webaccount_newpassword2"
              v-bind="componentField"
              :errorMessages="errors.newpassword2 ? [errors.newpassword2] : []"
              required
              newline>
            </fillin-component>
          </Field>

          <button
            v-if="!isInvite"
            id="webaccountmanagement_buttonchangepassword"
            type="button"
            class="button primary"
            :disabled="processing"
            @click.prevent="onSubmitPassword()">
            Change Password
          </button>
        </group-component>

        <group-component v-if="isInvite">
          <button
            id="webaccountmanagement_buttoncreate"
            type="button"
            class="button primary"
            :disabled="processing"
            @click.prevent="onSubmitAll()">
            Create Account
          </button>
        </group-component>
      </form>
    </VeeForm>
  </page-component>
</template>

<script>
export default {
  name: 'AccountSettings',
  props: {
    firstname: String,
    username: String,
    email: String,
    inviteid: String,
    optin: Boolean,
    outerrormessage: String
  },
  data() {
    return {
      header: '',
      crsf: App.settings.CSRFToken,
      baseHref: App.settings.BaseHref,
      internalUsername: '',
      internalEmail: '',
      internalPassword: '',
      internalNewPassword1: '',
      internalNewPassword2: '',
      internalOptIn: false,
      processing: false,
      isInvite: false
    }
  },
  created() {
    this.isInvite = this.inviteid ? true : false
    this.header = this.isInvite
      ? 'Create New Account'
      : `My Profile for ${this.firstname}`
    this.internalUsername = this.username
    this.internalEmail = this.email
    this.internalOptIn = this.optin
  },
  methods: {
    async onSubmitDetails() {
      let valid1, valid2

      await this.$refs.veeForm.validateField('username').then((result) => {
        valid1 = result.valid
      })

      await this.$refs.veeForm.validateField('email').then((result) => {
        valid2 = result.valid
      })

      if (!valid1) {
        document.querySelector('#webaccount_username_input').focus()
        return
      }

      if (!valid2) {
        document.querySelector('#webaccount_email_input').focus()
        return
      }

      this.submitForm()
    },

    async onSubmitPassword() {
      let valid1, valid2, valid3

      await this.$refs.veeForm.validateField('password').then((result) => {
        valid1 = result.valid
      })

      await this.$refs.veeForm.validateField('newpassword1').then((result) => {
        valid2 = result.valid
      })

      await this.$refs.veeForm.validateField('newpassword2').then((result) => {
        valid3 = result.valid
      })

      if (!valid1) {
        document.querySelector('#webaccount_password_input').focus()
        return
      }

      if (!valid2) {
        document.querySelector('#webaccount_newpassword1_input').focus()
        return
      }

      if (!valid3) {
        document.querySelector('#webaccount_newpassword2_input').focus()
        return
      }

      this.submitForm()
    },

    async onSubmitAll() {
      let valid,
        fieldToFocus = ''

      await this.$refs.veeForm.validate().then((result) => {
        valid = result.valid
        if (!valid && result.results) {
          if (!result.results.username.valid)
            fieldToFocus = '#webaccount_username_input'
          if (fieldToFocus === '' && !result.results.email.valid)
            fieldToFocus = '#webaccount_email_input'
          if (fieldToFocus === '' && !result.results.newpassword1.valid)
            fieldToFocus = '#webaccount_newpassword1_input'
          if (fieldToFocus === '' && !result.results.newpassword2.valid)
            fieldToFocus = '#webaccount_newpassword2_input'
        }
      })

      if (!valid) {
        if (fieldToFocus !== '') document.querySelector(fieldToFocus).focus()
        return
      }

      this.submitForm()
    },

    submitForm() {
      this.processing = true
      this.$refs.form.submit() // Use to submit form after checks
    }
  }
}
</script>
